import React from 'react';
import autoBind from 'react-autobind';
import TextField from 'material-ui/TextField';
import HelpToolTip from '../../components/HelpToolTip';
import style from './style';

export default class FieldArea extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.props.onChange({ name, value });
  }
  render() {
    const { helpText, successText, ...props } = this.props;
    props.onChange = this.handleChange;
    return (
      <div style={{ position: 'relative' }}>
        {props.tooltip && (
          <HelpToolTip
            style={{ position: 'absolute', top: 12, zIndex: 1 }}
            tip={props.tooltip}
          />
        )}
        <TextField
          style={{ marginBottom: 0 }}
          fullWidth
          multiLine
          rows={props.rows}
          floatingLabelStyle={props.tooltip ? { paddingLeft: 32 } : {}}
          floatingLabelFixed
          floatingLabelText={props.label}
          {...props}
        />
        {helpText && <span style={style.helpText}>{helpText}</span>}
        {successText && <span style={style.successText}>{successText}</span>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldArea/index.jsx